require('url');
import { getGuid } from 'owa-guid';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { setExtensibilityStateIsDirty } from 'owa-addins-store';
import { initializeExtensibilityContext } from 'owa-addins-boot';

declare function unescape(s: string): string;
var guid;
export function getExtensibilityFlightInfo() {
    return 'x';
}

//TODO :need to redo this This is done to resolve the crash in IE temporarily
export function addUrlParameter(url: string, key: string, value: string): string {
    if (!url || !key || !value) {
        throw new Error('Key and Value parameters should not be null');
    }

    var urlParts = url.split('#');
    var clientParams = urlParts.length == 1 ? '' : url.substr(url.indexOf('#'));

    if (url.indexOf('?') > 0) {
        url = urlParts[0] + '&' + key + '=' + value + clientParams;
    } else {
        url = urlParts[0] + '?' + key + '=' + value + clientParams;
    }
    return url;
}

export function getExchangeVersion(): string {
    // tslint:disable-next-line:no-string-literal
    return window['genericDiagnostics']['wsver'];
}

export function getOwaGuid() {
    if (guid == undefined) {
        guid = getGuid();
    }
    return guid;
}

export function getUserTimeZone() {
    return getUserConfiguration().UserOptions.TimeZone;
}
export function getBase64Encoded(data: string): string {
    const encodedString: string = encodeURIComponent(data);
    const escapedString: string = unescape(encodedString);
    return btoa(escapedString);
}

export function updateAddinSurface() {
    setExtensibilityStateIsDirty(true);
    initializeExtensibilityContext();
}
